import { Outlet } from "react-router-dom";

export default function Account() {
  return <Outlet />;
}
